module.exports = __webpack_public_path__ + "staticcomp/img/share.c9a78e0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/1/6/share.jpg
// module id = 1Q/H
// module chunks = 39